import { useState, useEffect } from "react";
import { Zap, X } from "lucide-react";
import QuizModal from "@/components/QuizModal";

const AnnouncementBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [isQuizOpen, setIsQuizOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 30000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsClosed(true);
  };

  const handleClick = () => {
    setIsQuizOpen(true);
  };

  if (isClosed) return null;

  return (
    <>
      <div
        onClick={handleClick}
        className={`fixed z-40 top-[25%] cursor-pointer hover:opacity-90 transition-all duration-500 ease-in-out ${isVisible ? 'left-0' : '-left-full'}`}
      >
        <div className="flex items-center gap-2 shadow-lg px-3 py-2 pr-7 rounded-r-2xl bg-[#c6e278]">
          <Zap className="w-4 h-4 text-gray-800 flex-shrink-0 fill-current animate-bounce" />
          <p className="text-gray-800 text-xs leading-tight font-bold">
            Votre lieu idéal en 30s<br />
            <span className="font-bold">Quiz Naboo</span>
          </p>
          <button
            onClick={handleClose}
            className="absolute right-1 top-1/2 -translate-y-1/2 p-1 hover:bg-black/10 rounded-full transition-colors"
            aria-label="Fermer"
          >
            <X className="w-3.5 h-3.5 text-gray-800" />
          </button>
        </div>
      </div>

      <QuizModal isOpen={isQuizOpen} onClose={() => setIsQuizOpen(false)} />
    </>
  );
};

export default AnnouncementBanner;
